/**
 * Whats That™
 *
 */
function WhatsThat(element) {
    if (!element) {
        return;
    }

    const _element = element;

    const toggle = _element.querySelector('[data-explanation-toggle]');
    const text = _element.querySelector('[data-explanation-text]');

    toggle?.addEventListener('click', () => {
        // Cast the state as a boolean
        let expanded = toggle.getAttribute('aria-expanded') === 'true' || false;

        // Switch the state
        toggle.setAttribute('aria-expanded', !expanded);
        // Switch the content's visibility
        text.inert = expanded;
    }, false);
}

export default WhatsThat;
